export default __webpack_public_path__ + "static/media/imgpartnermiddle.996ace51.png";